import Chart from 'react-apexcharts'
import { IDadosGraficosResultadosPorQuestaoPesquisaModel } from '../helpers/AnaliseResultadoHelper'
import { ISelectModel } from '../../../../modules/services/core/_models'
import Select from 'react-select'
import ApexCharts from 'apexcharts'


type Props = {
  dadosGraficosPesquisa: IDadosGraficosResultadosPorQuestaoPesquisaModel | undefined
  dimensoes: ISelectModel[]
  dimensaoSelecionada: ISelectModel | undefined
  setDimensao: Function
}

const GraficoResultadosPorQuestao = ({ dadosGraficosPesquisa, dimensoes, dimensaoSelecionada, setDimensao }: Props) => {
  let stackType: 'normal' | '100%' | undefined = '100%'

  const optionsBase = {
    chart: {
      stacked: true,
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      bar: {
        horizontal: true
      }
    },
    stroke: {
      width: 1,
      colors: ['#fff']
    },
    fill: {
      opacity: 1
    },
    legend: {
      offsetX: 40
    }
  }

  const baixarTodosGraficos = async (formato: 'png' | 'jpeg') => {
    if (!dadosGraficosPesquisa?.Categories) return

    for (let i = 0; i < dadosGraficosPesquisa.Categories.length; i++) {
      const id = `grafico-questao-${i}`
      try {
        const res: any = await ApexCharts.exec(id, 'dataURI')
        const link = document.createElement('a')
        link.href = res.imgURI
        link.download = `grafico_pergunta_${i + 1}.${formato}`
        link.click()
      } catch (error) {
        console.error(`Erro ao gerar imagem do gráfico ${id}:`, error)
      }
    }
  }

  return (
    <>
      <div className={`card m-0 p-0 ${dadosGraficosPesquisa ? '' : 'd-none'}`}>
        <div className='card-body m-0 p-0'>
          <div className='row justify-content-between m-8 mb-0 px-10'>
            <div className='fv-row col-lg-4'>
              <label className={`form-label text-gray-800`}>Selecione a dimensão</label>
              {dimensoes.length > 0 && (
                <Select
                  placeholder='Selecione...'
                  className='form-control-custom-select'
                  noOptionsMessage={() => 'Nenhuma opção encontrada'}
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      border: 'none',
                      backgroundColor: '$input-solid-bg',
                      borderRadius: '7px',
                      height: '3.4rem',
                      color: '#5e6278',
                      fontSize: '1.15rem'
                    }),
                    menu: (baseStyles) => ({
                      ...baseStyles,
                      backgroundColor: '#F9F9F9'
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      color: state.isFocused ? 'black' : '$input-solid-color'
                    })
                  }}
                  options={dimensoes.map((data) => ({
                    value: data.Id,
                    label: data.Nome
                  }))}
                  value={dimensaoSelecionada ? {
                    value: dimensaoSelecionada?.Id,
                    label: dimensaoSelecionada?.Nome
                  } : null}
                  isSearchable
                  onChange={(e: any) => setDimensao(e)}
                />
              )}
            </div>

            <div className='fv-row col-lg-3 d-flex align-items-end'>
              <div className='dropdown'>
                <button
                  className='btn btn-sm btn-light-primary dropdown-toggle'
                  type='button'
                  data-bs-toggle='dropdown'
                  aria-expanded='false'
                >
                  Baixar todos os gráficos
                </button>
                <ul className='dropdown-menu'>
                  <li>
                    <button className='dropdown-item' onClick={() => baixarTodosGraficos('png')}>Baixar PNG</button>
                  </li>
                  <li>
                    <button className='dropdown-item' onClick={() => baixarTodosGraficos('jpeg')}>Baixar JPEG</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {dadosGraficosPesquisa?.Categories.map((pergunta, index) => (
            <div key={index} style={{ marginBottom: '8px' }}>
              <div style={{ fontWeight: 500, fontSize: '14px', marginBottom: '4px' }}>
                {pergunta}
              </div>
              <Chart
                options={{
                  ...optionsBase,
                  colors: dadosGraficosPesquisa?.Colors ?? [],
                  xaxis: {
                    categories: [pergunta],
                    labels: { show: false }
                  },
                  yaxis: { show: false },
                  chart: {
                    ...optionsBase.chart,
                    id: `grafico-questao-${index}`
                  }
                }}
                series={dadosGraficosPesquisa.Series.map(s => ({
                  name: s.name,
                  data: [s.data?.[index] ?? 0]
                }))}
                type='bar'
                height={100}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export { GraficoResultadosPorQuestao }
